import { FC } from 'react';
import { FiltersMenuItem } from '../SearchFilters.styles';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { useLanguage } from 'context/AppContext';
import { FilterId } from '../types';

type TMenuItem = FC<{
  id: FilterId;
  onClick: (id: FilterId) => void;
  isActive: boolean;
  isHistorical?: boolean;
}>;

const Menuitem: TMenuItem = ({ id, isActive, isHistorical, onClick }) => {
  const lang = useLanguage()[0].DeliveryListPage.table;
  const label =
    id == 'dueDate'
      ? // on the past deliveries page, we need to change the label to Return Date but we still want to keep the search filter id as dueDate
        isHistorical
        ? lang['returnDate']
        : lang[id].label
      : lang[id];

  return (
    <FiltersMenuItem className={isActive ? 'active' : ''} onClick={() => onClick(id)}>
      {label}
      <NavigateNextIcon />
    </FiltersMenuItem>
  );
};

export default Menuitem;
